import * as React from 'react'
import { MemberListConnected } from './MemberListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const MemberListExamples = () => {
  return (
    <div className="MemberListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MemberListConnected />
      </Provider>
    </div>
  )
}
